import React, { Component } from 'react';
import { Button, Result } from 'antd';
import { history } from '../utils/history';

class NotFound extends Component {
  render() {
    return (
      <div>
        <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={
            <Button type="primary" onClick={() => history.push('/')}>
              Back Home
            </Button>
          }
        />
      </div>
    );
  }
}

export default NotFound;
